import { render, staticRenderFns } from "./PriceOver.vue?vue&type=template&id=5cc6c2e0&scoped=true&"
import script from "./PriceOver.vue?vue&type=script&lang=js&"
export * from "./PriceOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6c2e0",
  null
  
)

export default component.exports